<div class="">
  @if (subtitle) {
    <div class="uk-text-secondary uk-text-bold uk-text-italic uk-margin-bottom">{{subtitle}}</div>
  }
  <div class="uk-flex uk-flex-between uk-margin-small-bottom">
    <span>National monitoring</span>
    @if (monitoring === null) {
      <span class="material-icons uk-text-bold">N/A</span>
    }
    @if (monitoring === 'Yes') {
      <span class="material-icons uk-text-bold" style="color: #2D9D78">check</span>
    }
    @if (monitoring === 'No') {
      <span class="material-icons uk-text-bold" style="color: #D12D17">close</span>
    }
  </div>
  <div class="uk-flex uk-flex-between uk-margin-small-bottom">
    <span>Use cases</span>
    @if (useCases === null) {
      <span class="material-icons uk-text-bold">N/A</span>
    }
    @if (useCases === 'Yes') {
      <span class="material-icons uk-text-bold" style="color: #2D9D78">check</span>
    }
    @if (useCases === 'No') {
      <span class="material-icons uk-text-bold" style="color: #D12D17">close</span>
    }
  </div>
  <div class="uk-flex uk-flex-middle uk-margin-small-bottom">
    <span class="uk-text-bold uk-margin-right uk-text-lead">{{investments ? investments + ' M' : 'N/A'}}</span>
    <span class="">in financial investments</span>
  </div>
  <div class="uk-flex uk-flex-middle uk-margin-small-bottom">
    <span class="uk-text-bold uk-margin-right uk-text-lead">{{outputs ? outputs : 'N/A'}}</span>
    <span class="">{{outputsTitle}}</span>
  </div>
</div>
